import React from 'react';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';


export default class Splash_Career extends React.Component {
	constructor(props) {
		super(props);

		// Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
		ReactGA.initialize('UA-122650632-1');
		// This just needs to be called once since we have no routes in this case.
		ReactGA.pageview(window.location.pathname);
	}

    render() {
        return (
            <div id={isMobile ? "response-career-mobile" : "career"}>
                <div className="page_wrapper_full">
                    <div className="page_content_image">&nbsp;</div>
                    <div className="tcenter career_overplay">
                        <h2>Work at Versity</h2>
                        <h3>
							As second time entrepreneurs we are focused on building a great business,{isMobile ? "" : <br/>}
                            with great people. Our culture is fast paced, dynamic, but fun. We support{isMobile ? "" : <br/>}
                            and help our employees grow, but will also challenge them to do more.
                        </h3>
                    </div>
                </div>
                <div className={isMobile ? "career_bottom" : "page_wrapper career_bottom"}>
                    <h2>Check back for new opportunities</h2>
                    <h3>Please email resumes to <a href="mailto:info@versity.co">info@versity.co</a></h3>
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/commons/splash_career.js
 **/